var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "29px",
    viewBox: "0 0 25 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shipments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flag",
    transform: "translate(-20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    points: "35.6666667 2.63765358 35 0 20 0 20 29 23.3333333 29 23.3333333 15.7120743 31.3508772 15.7120743 32.0175439 18.4210526 45 18.4210526 45 2.63765358"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(23.947368, 1.315789)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-10",
    x: 14.4736842,
    y: 5.26315789,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-13",
    x: 2.63157895,
    y: 2.63157895,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-20",
    x: 17.1052632,
    y: 2.63157895,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-25",
    x: 5.26315789,
    y: 0,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-21",
    x: 17.1052632,
    y: 7.89473684,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-26",
    x: 5.26315789,
    y: 5.26315789,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-22",
    x: 17.1052632,
    y: 13.1578947,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-27",
    x: 5.26315789,
    y: 10.5263158,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-23",
    x: 14.4736842,
    y: 10.5263158,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-28",
    x: 2.63157895,
    y: 7.89473684,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-11",
    x: 11.8421053,
    y: 2.63157895,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-14",
    x: 0,
    y: 0,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-12",
    x: 11.8421053,
    y: 7.89473684,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-17",
    x: 0,
    y: 5.26315789,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-24",
    x: 11.8421053,
    y: 13.1578947,
    width: 2.63157895,
    height: 2.63157895
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-29",
    x: 0,
    y: 10.5263158,
    width: 2.63157895,
    height: 2.63157895
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.d1f72db6dc4e332499e586254eacf279.svg";
export { ForwardRef as ReactComponent };